import { createFileRoute } from '@tanstack/react-router'
import { FEATURE } from '@trellis/shared'
import { z } from 'zod'

import { FeatureGate, RoleGate } from '@/components/guards'
import { FeatureDisabledPage } from '@/pages/features/FeatureDisabledPage'
import {
  ALL_USER_STATUSES,
  UsersSettingsPage,
} from '@/pages/settings/users/UsersSettingsPage'

const UsersSettingsSearchSchema = z.object({
  status: z.enum(ALL_USER_STATUSES).optional(),
})

export const Route = createFileRoute('/_authenticated/_dashboard/settings/users/')({
  validateSearch: UsersSettingsSearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <FeatureGate feature={FEATURE.USER_MANAGEMENT} fallback={<FeatureDisabledPage />}>
      <RoleGate requires="ADMIN">
        <UsersSettingsPage />
      </RoleGate>
    </FeatureGate>
  )
}
